import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import IconAd from './icon-ad.svg?react'
import useComponentNode from '../_COMPONENT/useComponentNode.jsx'
import api from './apiAd.mjs'
import meta from './metaAd.mjs'
import Model from './ModelAd.mjs'
import PropertiesPane from './PropertiesPaneAd.jsx'
import FormChoose from './FormChooseAd.jsx'
import TableChoose from './TableChooseAd.jsx'

export default () => {
    const ComponentNode = useComponentNode()

    return extendNode(ComponentNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
        Model,
        PropertiesPane,

        attrNodes: {
            top: ['ATTR_AD_RESUME'],
        },

        canLinkType(map, node, type) {
            return /^([AD]O)$/.test(type)
        },

        getIcons(map, node) {
            return [
                <IconAd
                    key="type"
                    fill={Color.CYAN}
                />
            ]
        },

        getStyle(map, node) {
            return {
                ...this._getStyle(map, node, {borderColor: Color.CYAN}),
                shape: 'EllipseRectangle',
            }
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'DO'},
                {type: 'AO'},
            ]
        },

        async _atOwnerPush(map, node, event) {
            const d = await this._getPushData(map, node)
            event.detail.adList.push(d)
        },
    })
}
